import { render, staticRenderFns } from "./StatisticsMarksByFacultyYears.vue?vue&type=template&id=e20e9bc6"
import script from "./StatisticsMarksByFacultyYears.vue?vue&type=script&lang=js"
export * from "./StatisticsMarksByFacultyYears.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports